"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var comma = function (n) {
    return (Math.ceil(n * 1000) / 1000).toLocaleString('en-US');
};
var format = {
    parsePriceStr: function (priceStr) {
        var priceStrNormalized = priceStr
            .replace(/ /g, "")
            .replace(/,/g, "")
            .replace(/，/g, "")
            .replace(/　/g, "");
        if (priceStrNormalized.toLowerCase().indexOf("m") >= 0)
            return parseInt(priceStrNormalized.replace(/m/g, "")) * 1000000;
        if (priceStrNormalized.toLowerCase().indexOf("k") >= 0)
            return parseInt(priceStrNormalized.replace(/m/g, "")) * 1000;
        if (priceStrNormalized.toLowerCase().indexOf("b") >= 0)
            return parseInt(priceStrNormalized.replace(/b/g, "")) * 1000000000;
        if (priceStrNormalized.toLowerCase().indexOf("百萬") >= 0)
            return parseInt(priceStrNormalized.replace(/百萬/g, "")) * 1000000;
        if (priceStrNormalized.toLowerCase().indexOf("萬") >= 0)
            return parseInt(priceStrNormalized.replace(/萬/g, "")) * 10000;
        if (priceStrNormalized.toLowerCase().indexOf("億") >= 0)
            return parseInt(priceStrNormalized.replace(/億/g, "")) * 100000000;
        if (priceStrNormalized.toLowerCase().indexOf("千") >= 0)
            return parseInt(priceStrNormalized.replace(/千/g, "")) * 1000;
        if (priceStrNormalized.toLowerCase().indexOf("百万") >= 0)
            return parseInt(priceStrNormalized.replace(/百万/g, "")) * 1000000;
        if (priceStrNormalized.toLowerCase().indexOf("万") >= 0)
            return parseInt(priceStrNormalized.replace(/万/g, "")) * 10000;
        if (priceStrNormalized.toLowerCase().indexOf("亿") >= 0)
            return parseInt(priceStrNormalized.replace(/亿/g, "")) * 100000000;
        if (priceStrNormalized.toLowerCase().indexOf("千") >= 0)
            return parseInt(priceStrNormalized.replace(/千/g, "")) * 1000;
    },
    parseDateStr: function (dateStr) {
        // mm/dd/yyyy
        return new Date(dateStr);
    },
    currencyLease: function (num, lang, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        return format.currencyAdvance(num, SfilterTypeGroup_1.ListingPurposeType.Rent, lang, false, prefix, unlimited);
    },
    currencyDetailLease: function (num, lang, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        return format.currencyAdvance(num, SfilterTypeGroup_1.ListingPurposeType.Rent, lang, true, prefix, unlimited);
    },
    currencySale: function (num, lang, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        return format.currencyAdvance(num, SfilterTypeGroup_1.ListingPurposeType.Sale, lang, false, prefix, unlimited);
    },
    currencySaleLang: function (lang) { return function (num) {
        return format.currencySale(num, lang, "$");
    }; },
    currencyDetailSale: function (num, lang, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        return format.currencyAdvance(num, SfilterTypeGroup_1.ListingPurposeType.Sale, lang, true, prefix, unlimited);
    },
    currencyAdvance: function (num, type, lang, isDetailPage, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        if ((lang === LayoutState_1.Language.EN_US || lang.toLowerCase() === "en") &&
            isDetailPage) {
            return type === SfilterTypeGroup_1.ListingPurposeType.Sale
                ? format.currencyFull(num, prefix)
                : format.currencyFull(num, prefix);
        }
        if ((lang === LayoutState_1.Language.EN_US || lang.toLowerCase() === "en") &&
            !isDetailPage) {
            return type === SfilterTypeGroup_1.ListingPurposeType.Sale
                ? format.currencyShort(num, prefix, unlimited)
                : format.currencyShort(num, prefix, unlimited);
        }
        if ((lang === LayoutState_1.Language.ZH_HK || lang.toLowerCase() === "zh-hk") &&
            isDetailPage) {
            return type === SfilterTypeGroup_1.ListingPurposeType.Sale
                ? format.currencyFull(num, prefix)
                : format.currencyFull(num, prefix);
        }
        if ((lang === LayoutState_1.Language.ZH_HK || lang.toLowerCase() === "zh-hk") &&
            !isDetailPage) {
            return type === SfilterTypeGroup_1.ListingPurposeType.Sale
                ? format.currencyShortHk(num, prefix, unlimited)
                : format.currencyShortHk(num, prefix, unlimited);
        }
        if ((lang === LayoutState_1.Language.ZH_CN || lang.toLowerCase() === "zh-cn") &&
            isDetailPage) {
            return type === SfilterTypeGroup_1.ListingPurposeType.Sale
                ? format.currencyFull(num, prefix)
                : format.currencyFull(num, prefix);
        }
        if ((lang === LayoutState_1.Language.ZH_CN || lang.toLowerCase() === "zh-cn") &&
            !isDetailPage) {
            return type === SfilterTypeGroup_1.ListingPurposeType.Sale
                ? format.currencyShortZhCn(num, prefix, unlimited)
                : format.currencyShortZhCn(num, prefix, unlimited);
        }
        return format.currency(num, prefix, unlimited);
    },
    currency: function (num, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        if (!num)
            return "";
        var n = Math.ceil(num * 1000) / 1000;
        var mil = 1000000;
        var kilo = 1000;
        if (n / mil >= 1) {
            return "" + prefix + comma(n / mil) + "M";
        }
        if (n / kilo >= 1) {
            return "" + prefix + comma(n / kilo) + "K";
        }
        if (n === -1) {
            return unlimited;
        }
        return "" + prefix + n;
    },
    currencyShort: function (num, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        return format.currency(num, prefix, unlimited);
    },
    currencyPpsf: function (num, prefix) {
        if (prefix === void 0) { prefix = ""; }
        return format.currencyFull(num, prefix, 0);
    },
    currencyFull: function (num, prefix, decimalPlaces) {
        if (prefix === void 0) { prefix = ""; }
        if (decimalPlaces === void 0) { decimalPlaces = 2; }
        var factor = Math.pow(10, decimalPlaces);
        var n = Math.round(num * factor) / factor;
        return prefix + " " + comma(n);
    },
    currencyShortHk: function (n, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        return format.currencyZh(n, { y: "億", m: "萬", q: "千" }, prefix, unlimited);
    },
    currencyShortZhCn: function (n, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        return format.currencyZh(n, { y: "亿", m: "万", q: "千" }, prefix, unlimited);
    },
    currencyZh: function (n, t, prefix, unlimited) {
        if (prefix === void 0) { prefix = ""; }
        if (unlimited === void 0) { unlimited = ""; }
        var yi = 100000000;
        var tenThousand = 10000;
        var kilo = 1000;
        if (n === -1) {
            return unlimited;
        }
        if (n / yi >= 1) {
            return "" + prefix + comma(n / yi) + t.y;
        }
        if (n / tenThousand >= 1) {
            return "" + prefix + comma(n / tenThousand) + t.m;
        }
        if (n / kilo >= 1) {
            return "" + prefix + comma(n / kilo) + t.q;
        }
        return "" + prefix + n;
    },
    currencyRev: function (currencyString) {
        if (!currencyString)
            return null;
        var multiplier = 1;
        var newCurrencyString = currencyString
            .toLowerCase()
            .trim()
            .replace(/,/g, "");
        multiplier = newCurrencyString.indexOf("m") >= 0 ? 1000000 : multiplier;
        multiplier = newCurrencyString.indexOf("k") >= 0 ? 1000 : multiplier;
        newCurrencyString = newCurrencyString.replace(/[m|k]/g, "");
        return Number(newCurrencyString) * multiplier;
    },
    size: function (n, unlimited) {
        if (unlimited === void 0) { unlimited = "Unlimited"; }
        if (n === -1) {
            return unlimited;
        }
        return comma(n);
    },
    sizeRev: function (sizeString) {
        if (!sizeString)
            return null;
        var newSizeString = sizeString
            .trim()
            .toLowerCase()
            .replace(",", "");
        return Number(newSizeString);
    },
    comma: function (n) { return comma(n); },
    commaRounded: function (n) { return comma(Math.round(n)); },
    significantFigureFour: function (n) {
        return Number(n.toPrecision(4));
    },
    date: function (d) {
        var day = ("0" + d.getDate()).slice(-2);
        var month = ("0" + (d.getMonth() + 1)).slice(-2);
        return day + "." + month + "." + d.getFullYear();
    },
    dateTime: function (d) {
        var options = {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
        };
        return d.toLocaleDateString("en-US", options);
    },
    dateSlash: function (d) {
        var day = ("0" + d.getDate()).slice(-2);
        var month = ("0" + (d.getMonth() + 1)).slice(-2);
        return day + "/" + month + "/" + d.getFullYear();
    },
    dateFormat: function (d) {
        var options = { year: "numeric", month: "short", day: "numeric" };
        return d.toLocaleDateString("en-US", options);
    },
    dateStringToDate: function (dateStr) {
        if (dateStr.toString().indexOf("second") >= 0 ||
            dateStr.toString().indexOf("minute") >= 0 ||
            dateStr.toString().indexOf("hour") >= 0 ||
            dateStr.toString().indexOf("hrs") >= 0) {
            return new Date();
        }
        return new Date(dateStr);
    },
    dateAgo: function (d, t) {
        if (d.toString().indexOf("second") >= 0) {
            return t.today;
        }
        if (d.toString().indexOf("minute") >= 0) {
            return t.today;
        }
        if (d.toString().indexOf("hour") >= 0) {
            return t.today;
        }
        var date = new Date(d);
        var diffMs = new Date().getTime() - date.getTime();
        var daysDiff = diffMs / 1000 / 60 / 60 / 24;
        if (daysDiff === 0)
            return t.today;
        if (daysDiff === 1)
            return t.yesterday;
        if (daysDiff < 7)
            return daysDiff + " " + t.dayAgo;
        if (daysDiff < 30)
            return Math.ceil(daysDiff / 7) + " " + t.weekAgo;
        if (daysDiff < 365)
            return Math.ceil(daysDiff / 30) + " " + t.monthAgo;
        if (daysDiff < 3650)
            return Math.ceil(daysDiff / 3650) + " " + t.yearAgo;
        return Math.ceil(daysDiff / 3650) + " " + t.centuryAgo;
    },
    capitalize: function (str) {
        if (!str || !str.length)
            return str;
        return "" + str[0].toUpperCase() + str.substr(1);
    },
    normalize: function (str) {
        return str
            .toLowerCase()
            .replace(/&/g, "-")
            .replace(/ \)-/g, "-")
            .replace(/\)-/g, "-")
            .replace(/-\( /g, "-")
            .replace(/-\(/g, "-")
            .replace(/ \)/g, "")
            .replace(/\)/g, "")
            .replace(/\( /g, "-")
            .replace(/\(/g, "-")
            .replace(/'/g, "")
            .replace(/\./g, "")
            .replace(/,/g, "")
            .replace(/•/g, "")
            .replace(/ - /g, "-")
            .replace(/ /g, "-")
            .replace(/\//g, "-")
            .replace(/--/g, "-");
    },
    // Encourage HTML tags removal instead of dangerouslySetHTML
    // prevent HTML Injection from server-side
    stripTag: function (str) { return str.replace(/<\/?[^>]+(>|$)/g, " "); },
    print: function (str, args) {
        if (args === void 0) { args = []; }
        if (!args && !args.length)
            return str;
        args.reverse();
        var newStr = str;
        var i = 0;
        while (newStr.indexOf("{}") >= 0) {
            newStr = newStr.replace("{}", args.pop());
            i = i + 1;
            if (i === 100)
                break;
        }
        return newStr;
    },
};
exports.default = format;
